module.exports = __webpack_public_path__ + "static/media/nice-work.31eb007c.png";